import React__default, { useMemo, Children } from 'react';
import styled, { css } from 'styled-components';
import { setTestId } from '../../lib/testId.js';
import { HappyWebSystemError, useQueryChildComponents } from '../base/SystemComponent.js';
import { Button } from '../button/Button.js';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { Icon } from '../icon/Icon.js';
import { Box } from '../layout/Box.js';
import { Inline } from '../layout/Inline.js';
import { SelectInput, SelectOption } from './SelectInput.js';

const TagInputWrapper = styled(Box)`
  position: relative;
  width: fit-content;

  ${(props)=>!props.readOnly && css`
      &:hover,
      &:focus-within {
        background-color: ${COLOR_PALETTE.slateGrey5};
      }
    `}

  & > [${Inline.dataId}] {
    min-height: 1.5rem;
  }

  /* Overlay the Select Input on top of the 'current' tag */
  & [${SelectInput.dataId}] {
    position: absolute;
    width: 100%;
    left: -0.5rem;
    top: 0.125rem;
  }
  & [${Button.dataId}] {
    min-width: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    color: transparent;
    background-color: transparent;
  }
`;
const useSelectedTag = (children, value)=>{
    const tag = useMemo(()=>{
        let selected = undefined;
        Children.forEach(children, (child)=>{
            if (child && child.props.value === value) {
                selected = child.props.children;
            }
        });
        return selected;
    }, [
        children,
        value
    ]);
    return tag;
};
const TagInput = ({ children , ...props })=>{
    if (props.value === undefined) {
        throw new HappyWebSystemError("TagInput", "A value must be set");
    }
    const [options] = useQueryChildComponents(children, [
        SelectOption
    ]);
    const selected = useSelectedTag(options, props.value);
    return React__default.createElement(TagInputWrapper, {
        "data-hpy-web-tag-input": true,
        ...setTestId("TagInput-" + props.testId),
        padding: 0.5,
        border: "solid",
        borderColor: "slateGrey10",
        borderRadius: "medium",
        readOnly: props.readOnly
    }, React__default.createElement(Inline, {
        alignY: "center",
        gap: 0.5
    }, selected, !props.readOnly && React__default.createElement(Icon, {
        icon: "caret-down",
        size: "xsmall",
        color: "slateGrey80"
    }), React__default.createElement(SelectInput, {
        ...props,
        as: "button"
    }, children)));
};
TagInput.dataId = "data-hpy-web-tag-input";
TagInput.displayName = "TagInput";

export { TagInput };
